var exports = {
  "K": "noBreadcrumbs__y98ZNa",
  "V": "loggedOut__--dPuC",
};

module.exports = exports;
